const ExamSchedule = () => {
    return (
        <div id="exam" className="vision-card overview-card">

            {/* HEADER */}

            <div className="overview-header">

                <h2>
                    EXAMINATION SCHEDULE
                </h2>

                <div className="overview-title-line"></div>

            </div>


            {/* SCHOOL NAME */}

            <div className="overview-school-name">
                Nav Jeevan Mission School, Anandnagar
            </div>


            {/* CONTENT */}

            <div className="overview-content">

                <p>
                    <strong>Assessment &amp; Examination</strong>
                </p>

                <p>
                    At Nav Jeevan Mission School, Anandnagar, examinations and
                    assessments are an integral part of the teaching–learning
                    process. They help us evaluate students’ understanding,
                    monitor their academic progress and identify areas where
                    additional guidance and support may be required.
                </p>

                <p>
                    The school follows a systematic and well-planned examination
                    schedule in accordance with the academic calendar and
                    applicable CBSE guidelines.
                </p>


                {/* MAJOR ASSESSMENTS */}

                <div className="overview-section">

                    <div className="overview-section-heading">

                        <span className="overview-section-dot"></span>

                        <h3>
                            Major Assessments
                        </h3>

                    </div>

                    <p>
                        The academic session includes:
                    </p>
                    <br/>

                    <ul className="overview-strengths">

                        <li>
                            Periodic Tests / Unit Tests
                        </li>

                        <li>
                            Internal Assessments
                        </li>

                        <li>
                            Half-Yearly / Mid-Term Examination
                        </li>

                        <li>
                            Second Term / Annual Examination
                        </li>

                        <li>
                            Practical and Project Assessments, wherever applicable
                        </li>

                        <li>
                            Pre-Board Examinations for the appropriate classes
                        </li>

                        <li>
                            Board Examinations for Classes X and XII as scheduled by CBSE
                        </li>

                    </ul>

                </div>


                {/* EXAMINATION GUIDELINES */}

                <div className="overview-section">

                    <div className="overview-section-heading">

                        <span className="overview-section-dot"></span>

                        <h3>
                            Examination Guidelines
                        </h3>

                    </div>

                    <p>
                        Students are expected to:
                    </p>
                    <br/>

                    <ul className="overview-strengths">

                        <li>
                            Attend all examinations regularly and punctually.
                        </li>

                        <li>
                            Carry the required stationery and examination materials.
                        </li>

                        <li>
                            Prepare according to the syllabus and examination schedule issued by the school.
                        </li>


                        <li>
                            Follow all examination rules and maintain discipline and academic integrity.
                        </li>

                        <li>
                            Complete assignments, projects, practical work and other internal assessment requirements within the prescribed time.
                        </li>

                        <li>
                            Avoid absence from examinations except in genuine and approved circumstances.
                        </li>

                    </ul>

                </div>
                <br />

                {/* INFORMATION */}

                <p>
                    The detailed examination timetable, syllabus and instructions
                    will be communicated to students and parents through the
                    school’s official channels well in advance.
                </p>


                {/* QUOTE */}

                <div className="overview-highlight">

                    <span>
                        OUR BELIEF
                    </span>

                    <h3>
                        Learning Beyond Examinations
                    </h3>

                    <p>
                        “Examinations are not merely a test of memory, they are
                        an opportunity to demonstrate learning, discipline and
                        perseverance.”
                    </p>

                </div>


                {/* CLOSING */}

                <div className="overview-highlight">

                    <span>
                        NAV JEEVAN MISSION SCHOOL, ANANDNAGAR
                    </span>

                    <h3>
                        Learn • Prepare • Perform • Excel
                    </h3>

                </div>

            </div>

        </div>
    );
};

export default ExamSchedule;